module.exports = __webpack_public_path__ + "img/investing-hiw-image.a78b360d.png";